export const SET = 'Analysis/data/rows/SET';

export function setRows(rows) {
  return {
    type: SET,
    rows
  }
}